import {
  ExportToRuntimeStackRequest,
  FloorplanRevision,
  GenerateFloorplanRequest,
  GenerateTracksRequest,
  PoiConnectionsPerVehicleType,
} from '@thive/fddm-types';
import { v4 as uuid } from 'uuid';

import { formatMessage } from '@/modules/Notifications/helpers';
import { BaseNotification } from '@/modules/Notifications/helpers/types';

export const convertFloorplanRevisionToGenerateFloorplanRequest = (
  floorplanRevision: FloorplanRevision,
  withValidation: boolean,
): GenerateFloorplanRequest => ({
  jobId: uuid(),
  messageTs: new Date().toISOString(),
  metaData: floorplanRevision.metaData,
  setup: floorplanRevision.setup,
  design: floorplanRevision.design,
  validate: withValidation,
});

export const convertFloorplanRevisionToGenerateTracksRequest = (
  floorplanRevision: FloorplanRevision,
): GenerateTracksRequest => ({
  jobId: uuid(),
  messageTs: new Date().toISOString(),
  metaData: floorplanRevision.metaData,
  setup: floorplanRevision.setup,
  logicalSpaces: floorplanRevision.design.logicalSpaces,
  obstacles: floorplanRevision.design.obstacles,
  stations: floorplanRevision.floorplan.stations,
  poiConnectionsPerVehicleType:
    floorplanRevision.floorplan.vehicleLayouts.map<PoiConnectionsPerVehicleType>((layout) => ({
      vehicleTypeId: layout.vehicleTypeId,
      pois: layout.pois,
      poiConnections: layout.poiConnections,
    })),
});

export const convertFloorplanRevisionToExportToRuntimeStackRequest = (
  floorplanRevision: FloorplanRevision,
  generateTracks: boolean,
  generateProximityMatrix: boolean,
  generateTravelDurationCostMatrix: boolean,
): ExportToRuntimeStackRequest => ({
  jobId: uuid(),
  messageTs: new Date().toISOString(),
  metaData: floorplanRevision.metaData,
  referenceImage: floorplanRevision.uxonly.referenceImage,
  setup: floorplanRevision.setup,
  design: floorplanRevision.design,
  generateTracks,
  generateProximityMatrix,
  generateTravelDurationCostMatrix: {
    generate: generateTravelDurationCostMatrix,
  },
});

export const formatNotificationMessage = (
  args: string[],
  notification: BaseNotification,
  areaMap: Map<string, string>,
  action: () => void,
): BaseNotification => {
  const formattedArgs = args.map((arg) => (areaMap.has(arg) ? areaMap.get(arg) ?? arg : arg));

  return {
    ...notification,
    description: formatMessage(notification.description, formattedArgs),
    solution: formatMessage(notification.solution ?? '', formattedArgs),
    onClick: () => {
      action();
    },
  };
};
